import { AfterViewInit, Component, ElementRef, Input } from '@angular/core';
import { IPictureData } from 'src/app/dynamic-module/lib/public_api';
import { IUProperty } from 'src/app/shared/interface/umbraco-property';

export interface IContactPanelItemData {
  email: IUProperty<string>;
  emailColor: IUProperty<string>;
  firstName: IUProperty<string>;
  lastName: IUProperty<string>;
  location: IUProperty<string>;
  name: string;
  phone: IUProperty<string>;
  photo: IUProperty<IPictureData>;
  position: IUProperty<string>;
  textColor: IUProperty<string>;
}

@Component({
  selector: 'app-contact-panel-item',
  templateUrl: './contact-panel-item.component.html',
  styleUrls: ['./contact-panel-item.component.less']
})
export class ContactPanelItemComponent implements AfterViewInit {
  @Input() loadMedia: boolean;
  @Input() item: IContactPanelItemData;

  constructor(private hostRef: ElementRef) {}

  ngAfterViewInit(): void {
    this.setCustomThemeProperties(this.item);
  }

  private setCustomThemeProperties(d: IContactPanelItemData): void {
    if (d.emailColor && d.emailColor.value) {
      this.hostRef.nativeElement.style.setProperty(
        "--contact-panel-item-email-color",
        d.emailColor.value
      );
    }

    if (d.textColor && d.textColor.value) {
      this.hostRef.nativeElement.style.setProperty(
        "--contact-panel-item-text-color",
        d.textColor.value
      );
    }
  }
}
